import { render, staticRenderFns } from "./FavoriteComponent.vue?vue&type=template&id=971cf4de&scoped=true"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js"
import style0 from "./FavoriteComponent.vue?vue&type=style&index=0&id=971cf4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cf4de",
  null
  
)

export default component.exports